<template>
  <div class="wrapper">
    <div class="header">
      <span>{{ $t('project_management.project_resource.title.resource_language') }}</span>
    </div>
    <div class="body">
      <div class="number_se_wrapper">
        <span class='number_text'>{{ total_employees }}</span>
        <span class="se_text">SE</span>
      </div>
      <div class="number_language_wrapper">
        <div v-for="language in languages" class="language_wrapper">
          <div class="wrapper">
            <div class="name_wrapper">
              <img alt="" class="icon" src="@/assets/icons/anonymous.svg">
              <span class="name">{{ language.name }}</span>
            </div>
            <div class="content_wrapper">
              <div class="working_text_wrapper">
                <span class="working_text"
                      @click="onClickLanguageNumber(language.name, working_status)">{{
                    language.working_employee
                  }}</span></div>
              <div class="free_text_wrapper">
                <span class="free_text"
                      @click="onClickLanguageNumber(language.name, free_status)">{{
                    language.free_employee
                  }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {use} from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import {BarChart} from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  TimelineComponent
]);
import {mapGetters} from "vuex";
import {TimelineComponent} from 'echarts/components';

export default {
  name: "ResourceLanguage",
  components: {
    VChart,
  },
  data() {
    return {
      languages: [],
      total_employees: 0,
      working_status: 2,
      free_status: 1,
    };
  },
  async created() {
    await this.getData();
  },
  computed: {
    ...mapGetters({
      resourceSEStatistics: "project/resourceSEStatistics",
    }),
  },
  methods: {
    async getData() {
      try {
        await this.$store.dispatch("project/getResourceSEStatistics");
        this.total_employees = this.resourceSEStatistics.total_employees;
        this.languages = this.resourceSEStatistics.data;
      } catch (error) {
        console.log(error)
      }
    },
    onClickLanguageNumber(name, status) {
      let data = {
        query: {
          status,
          skill: name,
          division: 0,
          footCode: 0,
          info: '',
          startDate: moment().subtract(7, 'd').format('DD/MM/YYYY'),
          endDate: moment().format('DD/MM/YYYY'),
        }
      };
      this.$emit('on-click-language-number', data);
    }
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  .header {
    width: 100%;
    background: #17A896;
    border-radius: 10px;
    padding: 12px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.0703846px;
    color: #FFFFFF;
  }

  .body {
    width: 100%;
    display: flex;
    margin-top: 24px;

    .number_se_wrapper {
      width: 25%;
      background: #FFFFFF;
      border: 1px solid #D9D9D9;
      border-radius: 14px;
      text-align: center;
      padding: 170px 92px;

      .number_text {
        font-weight: 700;
        font-size: 60px;
        letter-spacing: 0.0703846px;
        color: #FF9100;
        margin-right: 10px;
      }

      .se_text {
        font-weight: 700;
        font-size: 60px;
        letter-spacing: 0.0703846px;
        color: #303C54;
      }
    }

    .number_language_wrapper {
      width: 75%;
      display: flex;
      flex-flow: row wrap;
      height: 431px;
      overflow: hidden scroll;

      &::-webkit-scrollbar {
        display: none;
      }

      .language_wrapper {
        width: 25%;
        padding: 0 6px 8px 6px;

        .wrapper {
          background: #FFFFFF;
          border: 1px solid #D9D9D9;
          border-radius: 14px;

          .name_wrapper {
            background: #E9E9E9;
            padding: 15px;
            text-align: center;
            vertical-align: middle;
            position: relative;
            border-radius: 14px 14px 0 0;

            .icon {
              width: 29px;
              height: 29px;
              position: absolute;
              left: 6px;
            }

            .name {
              font-weight: 400;
              font-size: 18px;
              letter-spacing: 0.0703846px;
              color: #303C54;
            }
          }

          .content_wrapper {
            padding: 17px 35px;
            display: flex;
            justify-content: center;

            .working_text_wrapper {
              padding-right: 30px;
              border-right: 1px solid #D9D9D9;
              height: 100%;

              .working_text {
                font-weight: 700;
                font-size: 40px;
                letter-spacing: 0.0703846px;
                color: #17A896;
                cursor: pointer;
              }
            }

            .free_text_wrapper {
              padding-left: 30px;

              .free_text {
                font-weight: 700;
                font-size: 40px;
                letter-spacing: 0.0703846px;
                color: #EA6057;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
</style>
